import router from '@/router'
import limitRouters from '@/router/limit.js'
import store from '@/store'

//? to：进入到哪个路由去
//? from：从哪个路由离开
//? next：路由的控制参数

router.beforeEach((to, from, next) => {
  // console.log('[ to.meta ] >', to.meta)
  // 白名单配置&&拦截配置
  if (limitRouters.indexOf(to.path) != -1) {
    // 限制名单限制判断
    const hasToken = store.getters.token
    if (!hasToken) {
      //todo 在限制页面缺少token操作
      //* 例如进入必须登录的页面
      // ...
      return false;
    }
  }

  //! web端title跟随路由配置 记得IOS好像不会生效貌似要使用一个插件才能解决此处忽略
  if (to.meta && to.meta != process.env.VUE_APP_NAME) {
    document.title = to.meta + ' 丨 ' + process.env.VUE_APP_NAME
  } else {
    document.title = process.env.VUE_APP_NAME
  }
  next();

})